import { useCreateFromJobDataMutation, useUpdateFromJobDataMutation } from "../../features/po/poSlice";
import { useState } from "react";
import Upload from '../../components/Upload';
import { Button, Link, Paper, Stack, Typography } from "@mui/material";

const DraftFromJobDataUploader = ({order=null, afterUpload=null}) => {
    const [ createFromJobDataMutation, {isSuccess, data} ] = useCreateFromJobDataMutation();
    const [ updateFromJobDataMutation, {isSuccess: isUpdateSuccess} ] = useUpdateFromJobDataMutation();

    if(isSuccess) {
        if(afterUpload) {
            afterUpload(data);
        }
    }
    if(isUpdateSuccess) {
        if(afterUpload) {
            afterUpload();
        }
    }

    return <Upload onUpload={async (data) => {
        if(order !== null) {
            await updateFromJobDataMutation({order_id: order.id, data: data.data})
        } else {
            await createFromJobDataMutation({data: data.data})
        }
    }} />
  };
  

const UploadJDBox = () => {
    const [errorInfo, setErrorInfo] = useState("");
    const [draftID, setDraftID] = useState("");

    return <Paper sx={{padding: 1}}><Stack direction="column" sx={{gap:1}}>
        <Typography>Upload a JobData.db:</Typography>
        <DraftFromJobDataUploader afterUpload={(data) => {
        if(!data.success) {
            if(data.error !== "") {
                setErrorInfo(data.error);
            } else {
                setErrorInfo("Unknown error");
            }
        } else {
            setErrorInfo("");
            setDraftID(data.draft_id);
        }
    }} />
    { draftID !== "" && <Link underline='none' href={`${process.env.REACT_APP_PREFIX}/purchaseorder?draft_id=${draftID}`}>Uploaded, go to draft</Link>}
    { errorInfo !== "" && <Typography color="red">{errorInfo}</Typography>}
    </Stack></Paper>;
};

export { UploadJDBox, DraftFromJobDataUploader }